import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminPharmaciesMergeRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/pharmacies/merge',
}).lazy(() =>
  import('pages/admin/PharmaciesMerge/AdminPharmaciesMergePage/AdminPharmaciesMergePage').then(
    (d) => d.Route
  )
);
